import React from 'react'
import { motion, Variants } from 'framer-motion'
// Vite 예시: ?url 없이 ReactComponent면 URL이 안 나옵니당
import textureUrl from '@/icons/pensil_check.svg'

const AnswerCheck: React.FC<{active:boolean,size?:number,className?:string}> = ({
  active, size=36, className='',
}) => {
  const pathD = 'M4 12l6 6L20 6'
  const variants: Variants = {
    hidden: { strokeDashoffset: 100, opacity: 0 },
    visible: { strokeDashoffset: 0, opacity: 1,
      transition:{ strokeDashoffset:{duration:0.4}, opacity:{duration:0.1} },
    },
  }

  return (
    <div className={className}>
      <motion.svg
        width={size} height={size}
        viewBox="0 0 24 24"
        fill="none"
        className="overflow-hidden"
      >
        <defs>
          <pattern
            id="pensilPattern"
            patternUnits="userSpaceOnUse"
            patternContentUnits="userSpaceOnUse"
            width={24} height={24}
            x="0" y="0"
          >
            <image
              href={textureUrl}
              x="0" y="0"
              width={24} height={24}
              preserveAspectRatio="none"
            />
          </pattern>
        </defs>

        {/* 디버그용: 패턴 보이는지 확인 */}
        {/* <rect x="0" y="0" width="24" height="24" fill="url(#pensilPattern)" /> */}

        <motion.path
          d={pathD}
          stroke={`url(#pensilPattern)`}
          strokeWidth={10}
          strokeDasharray={100}
          initial="hidden"
          animate={active ? 'visible' : 'hidden'}
          variants={variants}
        />
      </motion.svg>
    </div>
  )
}

export default AnswerCheck